import { render, staticRenderFns } from "./AddRawMaterials.vue?vue&type=template&id=5daab28c&scoped=true"
import script from "./AddRawMaterials.vue?vue&type=script&lang=js"
export * from "./AddRawMaterials.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5daab28c",
  null
  
)

export default component.exports